// extracted by mini-css-extract-plugin
export default {"inside":"_1GR8o","outside":"_2HRVT","wings":"n1130"};